export default __webpack_public_path__ + "static/production-3-446f9ac96898d118a34cef1934fca238.webp";